(function() {
    'use strict';

    angular.module('swif.publicLightning')
    .config(['$routeProvider', 'swifPublicLightningConstant', function($routeProvider, constants) {
        $routeProvider.when(constants.statistics.routes.statistics_view, {
            templateUrl: 'partials/openstc/tasks_statistics_view.html',
            controller: 'TasksStatisticsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check({ resources: ['d3'] });
                }]
            }
        });
    }]);
})();
